var map = {
	"./de/welcome-np.svg": 71671,
	"./en/welcome-np.svg": 82799,
	"./es/welcome-np.svg": 55532,
	"./fr/welcome-np.svg": 94024,
	"./it/welcome-np.svg": 67685,
	"./ko/welcome-np.svg": 33246,
	"./pl/welcome-np.svg": 4220,
	"./pt/welcome-np.svg": 38932,
	"./ru/welcome-np.svg": 12193,
	"./tr/welcome-np.svg": 85998
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 26550;